import React from "react";
import Col from 'react-bootstrap/Col';

const DetailBlock = props => {
  const { label, text } = props;

  return (
    <Col
      xs={12}
      md={6}
      style={{ paddingTop: "0px", paddingBottom: "0px" }}
    >
      <div
        style={{
          borderBottom: "1px solid #edeaea",
          paddingTop: "5px",
          paddingBottom: "5px"
        }}
      >
        <p
          style={{
            fontWeight: "bold",
            marginTop: "5px",
            marginBottom: "5px"
          }}
        >
          {label}
        </p>
        <p
          style={{
            marginTop: "5px",
            marginBottom: "5px",
            // whiteSpace: "pre",
            wordWrap: "break-word"
          }}
        >
          {/* text replace is making sure the line breaks are working for the address and the whiteSpace:"pre"
              is correctly formatting the breaks
             */}

          {// TODO: Work out what this code is currently doing
          null ? text.replace(/(?:\r\n|\r|\n)/g, "\n") : text}
        </p>
      </div>
    </Col>
  );
};

export default DetailBlock;
